import React from 'react';
import PropTypes from 'prop-types';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import CardTitle from 'components/ui/card/CardTitle';
import translate from 'components/hoc/translate';

const NotAllowedCard = (props) => {
    const {
        translate,
    } = props;

    return (
        <Card>
            <CardTitle title={ translate('page.not_authorised.title') } />

            <CardText>
                { translate('page.not_authorised.description') }
            </CardText>
        </Card>
    );
};

NotAllowedCard.propTypes = {
    translate: PropTypes.func.isRequired,
};

export default translate(NotAllowedCard);



// WEBPACK FOOTER //
// ./src/pages/UserNotAllowed/UserNotAllowed.js